module.exports = __webpack_public_path__ + "img/9.ab69f0ad.svg";